// Custom formatters for input values
const formatters = {
    phone: (value) => {
        // If already at max length (12 with formatting) and trying to add more, return existing value
        if (value.length > 12) {
            return value.slice(0, 12); // Return formatted number with dashes (XXX-XXX-XXXX)
        }

        const cleaned = value.replace(/\D/g, '');
        // Limit to 10 digits before formatting
        const trimmed = cleaned.slice(0, 10);
        const match = trimmed.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (!match) return '';

        const [, first, second, third] = match;
        if (!second) return first;
        if (!third) return `${first}-${second}`;
        return `${first}-${second}-${third}`;
    },
    ssn: (value) => {
        // If already at max length (11 with formatting) and trying to add more, return existing value
        if (value.length > 11) {
            return value.slice(0, 11); // Return formatted SSN with dashes (XXX-XX-XXXX)
        }

        const cleaned = value.replace(/\D/g, '');
        // Limit to 9 digits before formatting
        const trimmed = cleaned.slice(0, 9);
        const match = trimmed.match(/^(\d{0,3})(\d{0,2})(\d{0,4})$/);
        if (!match) return '';

        const [, first, second, third] = match;
        if (!second) return first;
        if (!third) return `${first}-${second}`;
        return `${first}-${second}-${third}`;
    },
    ein: (value) => {
        // If already at max length (10 with formatting) and trying to add more, return existing value
        if (value.length > 10) {
            return value.slice(0, 10); // Return formatted EIN with dash (XX-XXXXXXX)
        }

        const cleaned = value.replace(/\D/g, '');
        // Limit to 9 digits before formatting
        const trimmed = cleaned.slice(0, 9);
        const match = trimmed.match(/^(\d{0,2})(\d{0,7})$/);
        if (!match) return '';

        const [, first, second] = match;
        if (!second) return first;
        return `${first}-${second}`;
    },
    numeric: (value, maxLength) => {
        const cleaned = value.replace(/\D/g, '');
        // If maxLength is provided, limit the length
        if (maxLength) {
            return cleaned.slice(0, maxLength);
        }
        return cleaned;
    },
    currency: (value) => {
        const cleaned = value.replace(/[^0-9.]/g, '');
        // Limit to 2 decimal places and reasonable length
        const parts = cleaned.split('.');
        if (parts[0]?.length > 12) { // Limit whole number to 12 digits
            parts[0] = parts[0].slice(0, 12);
        }
        if (parts[1]?.length > 2) { // Limit decimal places to 2
            parts[1] = parts[1].slice(0, 2);
        }
        const limited = parts.join('.');

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(parseFloat(limited) || 0);
    }
};

// Validation rules for form fields
const validationRules = {
    phone: {
        pattern: /^\d{3}-\d{3}-\d{4}$/,
        message: 'Please enter a valid phone number (XXX-XXX-XXXX)'
    },
    ssn: {
        pattern: /^\d{3}-\d{2}-\d{4}$/,
        message: 'Please enter a valid SSN (XXX-XX-XXXX)'
    },
    ein: {
        pattern: /^\d{2}-\d{7}$/,
        message: 'Please enter a valid EIN (XX-XXXXXXX)'
    },
    email: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Please enter a valid email address'
    },
    required: {
        message: 'This field is required'
    }
};

export {formatters, validationRules };
